import {put, takeEvery} from "redux-saga/effects";
import {Salesman} from "../../../Models/Salesman";
import {fillItems} from "../../utils";
import {
    salesmanCreateError,
    salesmanCreateSuccess,
    salesmanGetError,
    salesmanGetSuccess,
    salesmanLoadError,
    salesmanLoadSuccess,
    salesmanUpdateError,
    salesmanUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* salesmanSagas() {
    yield takeEvery(TYPES.SALESMAN_GET_REQUEST, salesmanGetRequest);
    yield takeEvery(TYPES.SALESMAN_LOAD_REQUEST, salesmanLoadRequest);
    yield takeEvery(TYPES.SALESMAN_CREATE_REQUEST, salesmanCreateRequest);
    yield takeEvery(TYPES.SALESMAN_UPDATE_REQUEST, salesmanUpdateRequest);
}

function* salesmanGetRequest(action) {
    try {
        const response = yield Salesman.index({
            ...action.payload,
        });

        yield put(
            salesmanGetSuccess({
                ...fillItems(response, Salesman),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(salesmanGetError(error));
    }
}

function* salesmanLoadRequest(action) {
    try {
        const response = yield Salesman.find(action.payload);

        yield put(
            salesmanLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(salesmanLoadError(error));
    }
}

function* salesmanCreateRequest(action) {
    try {
        const response = yield Salesman.create();

        yield put(
            salesmanCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(salesmanCreateError(error));
    }
}

function* salesmanUpdateRequest(action) {
    try {
        const response = yield Salesman.update(action.payload.id, action.payload);

        yield put(
            salesmanUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(salesmanUpdateError(error));
    }
}
